import React, { useState } from 'react';
import './LandingPage.css';

const DEFAULT_ITEMS = [
    {
        q: 'What does CompCleared help me do?',
        a: 'CompCleared helps California employers organize a workplace violence prevention plan, incident records, training records, and available PDF exports.'
    },
    {
        q: 'Is CompCleared legal advice?',
        a: 'No. CompCleared provides compliance tools and templates for informational purposes only. It is not a law firm and does not create an attorney-client relationship.'
    },
    {
        q: 'Can I cancel?',
        a: 'Yes. You can cancel anytime. For billing or refund questions, email support@compcleared.com.'
    }
];

const FAQ = ({ items = DEFAULT_ITEMS, compact = false }) => {
    const [openIndex, setOpenIndex] = useState(null);

    return (
        <div style={{
            maxWidth: compact ? '800px' : '900px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
        }}>
            {items.map((item, idx) => {
                const isOpen = openIndex === idx;
                return (
                    <div
                        key={idx}
                        style={{
                            background: '#ffffff',
                            border: '1px solid #E2E8F0',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <button
                            onClick={() => setOpenIndex(isOpen ? null : idx)}
                            style={{
                                width: '100%',
                                padding: '20px 24px',
                                background: 'transparent',
                                border: 'none',
                                textAlign: 'left',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontFamily: 'inherit',
                                fontSize: '17px',
                                fontWeight: '600',
                                color: '#0f172a'
                            }}
                            aria-expanded={isOpen}
                        >
                            <span>{item.q}</span>
                            <span style={{
                                fontSize: '24px',
                                color: '#64748B',
                                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                                transition: 'transform 0.2s ease',
                                marginLeft: '16px',
                                flexShrink: 0
                            }}>+</span>
                        </button>
                        {isOpen && (
                            <div style={{
                                padding: '0 24px 20px 24px',
                                color: '#475569',
                                lineHeight: '1.7',
                                fontSize: '15px'
                            }}>
                                {item.a}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default FAQ;
